import { render } from "./ResellersBills.vue?vue&type=template&id=2a7c147b&scoped=true"
import script from "./ResellersBills.vue?vue&type=script&lang=js"
export * from "./ResellersBills.vue?vue&type=script&lang=js"

import "./ResellersBills.vue?vue&type=style&index=0&id=2a7c147b&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\ssradius\\frontend_tr\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a7c147b"]])

export default __exports__